import DeviceDataSource from "./DeviceDataSource.js";
import DeviceGroupDataSource from "./DeviceGroupDataSource.js";
import DeviceTypeDataSource from "./DeviceTypeDataSource.js";
import FirmwareApplicationDataSource from "./FirmwareApplicationDataSource.js";
import FirmwareComponentDataSource from "./FirmwareComponentDataSource.js";
import FirmwareReleaseDataSource from "./FirmwareReleaseDataSource.js";
import { install } from "./PluginSetup.js";
export default {
  DeviceDataSource,
  DeviceGroupDataSource,
  DeviceTypeDataSource,
  FirmwareApplicationDataSource,
  FirmwareComponentDataSource,
  FirmwareReleaseDataSource,
  install
};